import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');

const SignInStore = require('../../stores/SignInStore');
const AccountActions = require('../../actions/AccountActions');
const ForgeError = require('../../util/error');
import ErrorBox from '../common/ErrorBox';
import Tooltip from '../common/Tooltip';

const propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    buttonTitle: PropTypes.string,
};

const defaultProps = {
    className: '',
    disabled: false,
    buttonTitle: '',
};

class AccountSettingsEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            signInStoreState: SignInStore.getState(),
            enableCommentsEmail: null,
            getSettingsActionId: null,
            updateSettingsActionId: null,
            saveEnabled: false,
            error: null
        };

        this.onEnableCommentsEmailChange = this.onEnableCommentsEmailChange.bind(this);
        this.onEnableShareLinksChange = this.onEnableShareLinksChange.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.unsubscribes = [SignInStore.listen(this.onSignInStoreStateChange.bind(this))]
    }

    UNSAFE_componentWillMount() {
        AccountActions.getUserSettings(uuid.v4(), {
            userId: this.state.signInStoreState.userInfo.id,
        });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => unsubscribeCallback());
    }

    onSignInStoreStateChange(newState) {
        let additionalState = {};

        if (newState.action.id === this.state.updateSettingsActionId ) {
            additionalState = {
                ...additionalState,
                updateSettingsActionId: null,
                enableCommentsEmail: null,
                enableShareLinks: null,
                enableStudentFeedback: null,
                saveEnabled: !!newState.action.error, //disable save on successful action completion
                error: newState.action.error
            };
        }

        this.setState({ signInStoreState: newState, ...additionalState });
    }

    onEnableCommentsEmailChange(e) {
        this.setState({ enableCommentsEmail: e.target.checked, saveEnabled: true });
    }

    onEnableShareLinksChange(e) {
        this.setState({ enableShareLinks: e.target.checked, saveEnabled: true });
    }

    onEnableStudentFeedbackChange=(e)=>{
        this.setState({ enableStudentFeedback: e.target.checked, saveEnabled: true });
    }

    saveHandler() {
        const actionId = uuid.v4();
        this.setState({ updateSettingsActionId: actionId }, () => {
            AccountActions.updateUserSettings(actionId, {
                userId: this.state.signInStoreState.userInfo.id,
                enableCommentsEmail: this.state.enableCommentsEmail,
                enableShareLinks: this.state.enableShareLinks,
                enableStudentFeedback: this.state.enableStudentFeedback,
            });
        });
    }

    render() {
        const userSettings = this.state.signInStoreState.userSettings;
        if (!userSettings) return null;

        return (
            <Row className={`${this.props.className}`}>
                <div className="col-12">
                    <h2>Account Settings</h2>
                    <hr/>
                    <ErrorBox error={this.state.error} />
                    <Form.Row>
                        <Form.Group controlId="acct-settings-comments" bsPrefix="form-group col-12">
                            {/* use 'inline' prop to allow Tooltip to directly follow label */}
                            <Form.Check
                                inline
                                checked={typeof this.state.enableCommentsEmail === 'boolean' ? this.state.enableCommentsEmail : userSettings.enable_comments_email}
                                onChange={this.onEnableCommentsEmailChange}
                                disabled={this.props.disabled}
                                label="Enable Comments Email"
                            />
                            <Tooltip id="st-comment-email" placement="right">
                                Receive email updates regarding comments. An email will be sent when:
                                <ul className="listDiscIndent__spacedSm listBulletSpacingAdjust margin-top-sm font-size-13px">
                                    <li>A new comment has been assigned to you.</li>
                                    <li>An existing comment has been assigned to you.</li>
                                    <li>A comment assigned to you has a new reply.</li>
                                    <li>The status of a comment assigned to you has been changed.</li>
                                </ul>
                            </Tooltip>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group controlId="acct-settings-share-links" bsPrefix="form-group col-12">
                            {/* use 'inline' prop to allow Tooltip to directly follow label */}
                            <Form.Check
                                inline
                                checked={typeof this.state.enableShareLinks === 'boolean' ? this.state.enableShareLinks : userSettings.enable_share_links}
                                onChange={this.onEnableShareLinksChange}
                                disabled={this.props.disabled}
                                label="Enable Share Links"
                            />
                            <Tooltip id="st-share-links" placement="right">
                                Include <em className="font-style-italic">Share Link</em> in Activity view. Disabling this will hide the link.
                            </Tooltip>
                        </Form.Group>
                        <Form.Group controlId="acct-settings-student-feedback" bsPrefix="form-group col-12">
                            {/* use 'inline' prop to allow Tooltip to directly follow label */}
                            <Form.Check
                                inline
                                checked={typeof this.state.enableStudentFeedback === 'boolean' ? this.state.enableStudentFeedback : userSettings.enable_student_feedback}
                                onChange={this.onEnableStudentFeedbackChange}
                                disabled={this.props.disabled}
                                label="Enable Student Feedback"
                            />
                            <Tooltip id="st-student-feedback" placement="right">
                                Enable <em className="font-style-italic">Student Feedback</em> during Activity student attempts. Disabling this will hide the feedback button.
                            </Tooltip>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <div className="col-12">
                            <Button
                                disabled={this.props.disabled || !this.state.saveEnabled || !!this.state.updateSettingsActionId}
                                onClick={this.saveHandler}
                                title={this.props.buttonTitle}
                            >
                                save settings
                            </Button>
                        </div>
                    </Form.Row>
                </div>
            </Row>
        );
    }
}

AccountSettingsEdit.propTypes = propTypes;
AccountSettingsEdit.defaultProps = defaultProps;

export default AccountSettingsEdit;